(function(){
'use strict';
var html=document.documentElement,service='tours',applying=false,swapTimer=0,lastHeaderHeight=-1;
function qs(s,r){return(r||document).querySelector(s)}
function qsa(s,r){return Array.from((r||document).querySelectorAll(s))}
function header(){return qs('.header-nav-container')}
function chipRoot(){return qs('.chips-wrapper')}
function routeSignature(){return((location.pathname||'')+' '+(document.title||'')).toLowerCase()}
function routeService(){var s=routeSignature();if(/wellness-spa-experiences|vip-services|therapeutic-oriental-massage-by-myo|massage-layout|hotel-pick-up-with-professional-driver-within-lisbon|lisbon-porto-premium-transfer-optional-stops/.test(s))return'vip';if(/accommod|accommodation|alojamento|alojamentos|hotel-stays|stays/.test(s))return'stays';return'tours'}
function routeDestination(){var s=routeSignature();if(/day-trips-italy|from-naples-amalfi-coast-private-tour-with-driver|\bitaly\b|\bitalia\b/.test(s))return'italy';if(/\/collections\/(walking-tours|day-trips|boat-tours)(?:\/|$)|\/products\//.test(s))return'portugal';return''}
function destination(){var x=routeDestination();if(x)return x;var r=chipRoot(),d=(html.getAttribute('data-pmy-destination')||(r&&r.getAttribute('data-pmy-destination'))||'').toLowerCase();if(d==='italy'||d==='italia')return'italy';try{var st=(localStorage.getItem('pmy_destination')||'').toLowerCase();if(st==='italy'||st==='italia')return'italy'}catch(e){}return'portugal'}
function syncDestinationContext(){var x=routeDestination();if(!x)return;html.setAttribute('data-pmy-destination',x);var r=chipRoot();if(r)r.setAttribute('data-pmy-destination',x);try{localStorage.setItem('pmy_destination',x)}catch(e){}}
function signature(el){return[el.getAttribute('href')||'',el.getAttribute('data-collection')||'',el.getAttribute('data-handle')||'',el.textContent||''].join(' ').toLowerCase()}
function isTour(s){return/walking[\s_-]*tours?|day[\s_-]*trips?|boat[\s_-]*tours?/.test(s)}
function isVip(s){return/wellness[\s_-]*spa[\s_-]*experiences?|vip[\s_-]*services?/.test(s)}
function setDisplay(el,show){if(!el)return;if(show)el.style.removeProperty('display');else el.style.setProperty('display','none','important')}
function installSwapStyle(){
  if(document.getElementById('pmy-chip-swap-style'))return;
  var style=document.createElement('style');
  style.id='pmy-chip-swap-style';
  style.textContent='@media (min-width:901px){html[data-pmy-service] .chips-wrapper .chips-scroll{opacity:1!important;transition:opacity .09s ease!important;will-change:opacity!important}html[data-pmy-service] .chips-wrapper .chips-scroll.pmy-chip-swap-out{opacity:0!important;pointer-events:none!important}}@media (prefers-reduced-motion:reduce){html[data-pmy-service] .chips-wrapper .chips-scroll{transition:none!important}}';
  document.head.appendChild(style);
}
function syncScrolled(){var h=header();html.classList.toggle('pmy-header-is-scrolled',!!(h&&h.classList.contains('header-scrolled')))}
function syncBodyOffset(){var h=header();if(!h||!document.body)return;requestAnimationFrame(function(){var n=Math.ceil(h.getBoundingClientRect().height);if(n===lastHeaderHeight)return;lastHeaderHeight=n;document.body.style.paddingTop=n+'px'})}
function syncMobileDestination(){var button=qs('.pmy-mobile-destination');if(!button)return;var d=destination();button.textContent=d==='italy'?'🇮🇹 IT ⌄':'🇵🇹 PT ⌄';button.setAttribute('aria-label',d==='italy'?'Destination: Italy':'Destination: Portugal')}
function ensureMobileDestination(){var services=qs('.pmy-mobile-services');if(!services||qs('.pmy-mobile-destination',services))return;var button=document.createElement('button');button.type='button';button.className='pmy-mobile-destination';button.addEventListener('click',function(){var next=destination()==='italy'?'portugal':'italy',option=qs('.destination-option[data-destination="'+next+'"]',chipRoot());if(option)option.click()});services.insertBefore(button,services.firstChild);syncMobileDestination()}
function filterChips(){
  if(applying)return;
  applying=true;
  try{
    var h=header(),r=chipRoot();if(!h||!r)return;
    syncDestinationContext();
    html.setAttribute('data-pmy-service',service);
    h.setAttribute('data-pmy-service',service);
    var p=qs('.destination-picker',r),sc=qs('.chips-scroll',r),chips=qsa('.chip-item',r);
    if(!chips.length&&sc)chips=qsa('a,button',sc);
    r.style.removeProperty('display');
    setDisplay(p,true);
    if(service==='stays'){
      setDisplay(sc,false);
      chips.forEach(function(c){setDisplay(c,false)});
    }else if(service==='tours'){
      setDisplay(sc,true);
      var d=destination();
      chips.forEach(function(c){var sig=signature(c),cd=(c.getAttribute('data-pmy-destination')||'portugal').toLowerCase();if(cd==='italia')cd='italy';setDisplay(c,isTour(sig)&&cd===d)});
    }else{
      setDisplay(sc,true);
      chips.forEach(function(c){setDisplay(c,isVip(signature(c)))});
    }
    syncScrolled();
    syncBodyOffset();
  }finally{applying=false}
}
function normalizeService(n){return/^(tours|stays|vip)$/.test(n)?n:'tours'}
function toggleActive(){qsa('.pmy-platform-vertical[data-service]').forEach(function(b){b.classList.toggle('is-active',b.getAttribute('data-service')===service)})}
function setService(n,animate){
  service=normalizeService(n);
  toggleActive();
  var r=chipRoot(),sc=r&&qs('.chips-scroll',r);
  var reduced=false;try{reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches}catch(e){}
  if(!animate||window.innerWidth<=900||!sc||reduced){
    if(swapTimer){clearTimeout(swapTimer);swapTimer=0}
    if(sc)sc.classList.remove('pmy-chip-swap-out');
    filterChips();
    return;
  }
  if(swapTimer)clearTimeout(swapTimer);
  sc.classList.add('pmy-chip-swap-out');
  swapTimer=setTimeout(function(){
    swapTimer=0;
    filterChips();
    requestAnimationFrame(function(){requestAnimationFrame(function(){sc.classList.remove('pmy-chip-swap-out')})});
  },95);
}
function onClick(e){var d=e.target.closest&&e.target.closest('.pmy-platform-vertical[data-service]');if(d)setService(d.getAttribute('data-service'),true)}
function init(){
  installSwapStyle();
  var tries=0;
  (function wait(){
    var h=header(),r=chipRoot(),nav=qs('.pmy-platform-vertical[data-service]');
    if(!h||!r||!nav){if(++tries<50)return setTimeout(wait,80);return}
    document.addEventListener('click',onClick,false);
    document.addEventListener('pmy:destination-change',function(){syncMobileDestination();if(swapTimer)return;requestAnimationFrame(filterChips)});
    new MutationObserver(function(records){
      var headerClassChanged=false,childChanged=false;
      records.forEach(function(record){if(record.type==='attributes'&&record.target===h&&record.attributeName==='class')headerClassChanged=true;if(record.type==='childList')childChanged=true});
      if(headerClassChanged){syncScrolled();syncBodyOffset()}
      if(childChanged)ensureMobileDestination();
    }).observe(h,{attributes:true,childList:true,subtree:true,attributeFilter:['class']});
    syncDestinationContext();
    setService(routeService(),false);
    ensureMobileDestination();
    setTimeout(ensureMobileDestination,500);
  })();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();